// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3Ws-p","actionsCol":"EnrolledClinics_actionsCol__1F8dV"};